module.exports = __webpack_public_path__ + "static/media/Sean Stevens Headshot.629a411d.jpeg";